"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FutureDirect = exports.FutureOrderStatus = exports.FutureIncomeType = void 0;
var FutureIncomeType;
(function (FutureIncomeType) {
    FutureIncomeType["TRANSFER"] = "TRANSFER";
    FutureIncomeType["WELCOME_BONUS"] = "WELCOME_BONUS";
    FutureIncomeType["REALIZED_PNL"] = "REALIZED_PNL";
    FutureIncomeType["FUNDING_FEE"] = "FUNDING_FEE";
    FutureIncomeType["COMMISSION"] = "COMMISSION";
    FutureIncomeType["INSURANCE_CLEAR"] = "INSURANCE_CLEAR";
})(FutureIncomeType = exports.FutureIncomeType || (exports.FutureIncomeType = {}));
var FutureOrderStatus;
(function (FutureOrderStatus) {
    FutureOrderStatus["open"] = "open";
    FutureOrderStatus["rejected"] = "rejected";
    FutureOrderStatus["canceled"] = "canceled";
    FutureOrderStatus["canceling"] = "canceling";
    FutureOrderStatus["closed"] = "closed";
})(FutureOrderStatus = exports.FutureOrderStatus || (exports.FutureOrderStatus = {}));
var FutureDirect;
(function (FutureDirect) {
    FutureDirect["next"] = "next";
    FutureDirect["prev"] = "prev";
})(FutureDirect = exports.FutureDirect || (exports.FutureDirect = {}));
